import { formulaNew } from "../../formula/formulaNew";
import type { DocMigration } from "../docMigration";

const DEFAULT_EAVE_OVERHANG = 12;
const DEFAULT_EAVE_EXTENSION_AT_COPLANAR_RAKE = 6;

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_166: DocMigration = {
  maxSchemaVersion: "0.0.166",
  description: "Roof eave extension settings",
  apply(json: any) {
    const { settings: allSettings, roofs } = json;

    const getFormula = (settings: any, param: string, defaultValue: number = 0): string => {
      const val = settings[param];
      if (val !== undefined) {
        return val.type === "FORMULA" ? val.formula : val.toString();
      } else {
        return defaultValue.toString();
      }
    };

    // roof settings
    for (const settingsId in allSettings) {
      const settings = allSettings[settingsId];
      if (settings.type !== "ROOF_SETTINGS") {
        continue;
      }

      if (settings.eaveExtensionAtCoplanarRake !== undefined) {
        const eaveOverhang = getFormula(settings, "eaveOverhang", DEFAULT_EAVE_OVERHANG);
        const eaveExtensionAtCoplanarRake = getFormula(
          settings,
          "eaveExtensionAtCoplanarRake",
          DEFAULT_EAVE_EXTENSION_AT_COPLANAR_RAKE,
        );

        settings.eaveExtensionAtCoplanarRake = formulaNew(`${eaveExtensionAtCoplanarRake} - ${eaveOverhang}`);
      }
    }

    // roof instances
    for (const roofId in roofs) {
      const { roofSettings = {} } = roofs[roofId];

      if (roofSettings.eaveExtensionAtCoplanarRake !== undefined) {
        const eaveOverhang = getFormula(roofSettings, "eaveOverhang", DEFAULT_EAVE_OVERHANG);
        const eaveExtensionAtCoplanarRake = getFormula(
          roofSettings,
          "eaveExtensionAtCoplanarRake",
          DEFAULT_EAVE_EXTENSION_AT_COPLANAR_RAKE,
        );

        roofSettings.eaveExtensionAtCoplanarRake = formulaNew(`${eaveExtensionAtCoplanarRake} - ${eaveOverhang}`);
      }
    }

    return json;
  },
};

export default migration_0_0_166;
